<app-dialog-base titleTranslationKey="files.rename.dialog-title">
  <ng-container content>
    <form [formGroup]="form" (ngSubmit)="submit()" id="file-rename-dialog-form">
      <mat-form-field class="full-width">
        <mat-label *ngIf="!data.isFolder">{{ 'files.file-name' | translate }}</mat-label>
        <mat-label *ngIf="data.isFolder">{{ 'files.folder-name' | translate }}</mat-label>
        <input matInput formControlName="fileName" />
        <span *ngIf="fileExtension" matSuffix class="suffix-aligned-with-input">{{ fileExtension }}</span>
        <mat-error *ngIf="form.get('fileName')!.hasError('required')">
          {{ 'files.rename.name-required' | translate }}
        </mat-error>
        <mat-error *ngIf="form.get('fileName')!.hasError('invalidFilename')">
          {{ 'files.rename.name-invalid' | translate: { invalidChars: data.invalidFileAndFolderNameCharacters.join(' ') } }}
        </mat-error>
      </mat-form-field>
    </form>
  </ng-container>

  <ng-container actions>
    <button mat-stroked-button color="primary" type="button" [routerLink]="[]" (click)="close()" mat-button>
      {{ 'shared.cancel' | translate }}
    </button>
    <button mat-flat-button color="primary" type="submit" [disabled]="!form.valid || isNameUnchanged()" form="file-rename-dialog-form">
      {{ 'files.rename.dialog-title' | translate }}
    </button>
  </ng-container>
</app-dialog-base>
